import { render } from "./PublicHome.vue?vue&type=template&id=66330d3c&scoped=true"
import script from "./PublicHome.vue?vue&type=script&lang=js"
export * from "./PublicHome.vue?vue&type=script&lang=js"

import "./PublicHome.vue?vue&type=style&index=0&id=66330d3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66330d3c"]])

export default __exports__